import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meeting: null,
};
export const meetingSlice = createSlice({
  name: "meeting",
  initialState,
  reducers: {
    setMeeting: (state, action) => {
      state.meeting = action.payload;
    },
    setLogoutMeeting: (state, action) => {
      state.meeting = null;
    },
  },
});
export const { setMeeting, setLogoutMeeting } = meetingSlice.actions;

export default meetingSlice.reducer;
